import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import { cashingApis } from 'apis/common/cashingApis';
import ErrorMessage from 'apis/ErrorMessage';
import {
  fetchNoticeDropList,
  oldNoticeApi,
} from 'apis/operation/oldNoticeApis';
import fetchLocalizingInput from 'hooks/fetchLocalizingInput';

export const useNoticeList = (projectId: string | number = -1) => {
  const { status, data, error, isFetching } = useQuery(
    ['noticeList', projectId],
    async () => await oldNoticeApi.read(projectId),
    {
      enabled: !!projectId,
      select: (data) => {
        const newArr: any = data.map((v, i) => ({ ...v, key: i }));

        return newArr;
      },
    },
  );
  return { status, data, error, isFetching };
};

export const useNoticeDetail = (
  projectId: string | number = -1,
  noticeId: string,
  setDetailData,
  langList,
  setLangList,
) => {
  const { status, data, error, isFetching } = useQuery(
    ['noticeDetail', noticeId, projectId],
    async () => await oldNoticeApi.detail(noticeId),
    {
      enabled: !!noticeId,
      onSuccess: (data) => {
        if (data.detail.length > 0) {
          setDetailData(data.detail[0], {
            notice_no: noticeId,
            connected_project: projectId,
          });
        }

        if (data.langList.length > 0) {
          fetchLocalizingInput(data.langList, setLangList);
        } else {
          fetchLocalizingInput(langList, setLangList);
        }
      },
    },
  );
  return { status, data, error, isFetching };
};

export const useNoticeRegister = () => {
  const queryClient = useQueryClient();

  return useMutation(async (props: any) => await oldNoticeApi.register(props), {
    // onMutate: props => {},
    onSuccess: async (props) => {
      queryClient.invalidateQueries(['noticeList']);
      message.success('공지사항 저장 완료 ', 1);

      // 캐싱 비우기
      await cashingApis.notice_promotion_cash();
    },
    onError: (err: any) => {
      if (err?.response) {
        ErrorMessage(err.response.status, err.response.data);
      }
    },
  });
};

export const useNoticeUpdate = () => {
  const queryClient = useQueryClient();

  return useMutation(async (props: any) => await oldNoticeApi.update(props), {
    // onMutate: props => {
    //   console.log(props);
    // },
    onSuccess: async (props) => {
      queryClient.invalidateQueries(['noticeList']);
      message.success('공지사항 저장 완료 ', 1);

      // 캐싱 비우기
      await cashingApis.notice_promotion_cash();
    },
    onError: (err: any) => {
      if (err?.response) {
        ErrorMessage(err.response.status, err.response.data);
      }
    },
  });
};

export const useNoticeDelete = () => {
  const queryClient = useQueryClient();

  return useMutation(async (props: any) => await oldNoticeApi.delete(props), {
    // onMutate: props => {},
    onSuccess: async (props) => {
      queryClient.invalidateQueries(['noticeList']);
      message.success('공지사항 삭제 완료 ', 1);

      // 캐싱 비우기
      await cashingApis.notice_promotion_cash();
    },
    onError: (err: any) => {
      if (err?.response) {
        ErrorMessage(err.response.status, err.response.data);
      }
    },
  });
};

export const useDetailImgDropList = (projectId: string) => {
  const { status, data, error, isFetching } = useQuery(
    ['detailImgDropList', projectId],
    async () => await fetchNoticeDropList.detailImageList(projectId),
  );
  return { status, data, error, isFetching };
};
export const useBannerImgDropList = (projectId: string) => {
  const { status, data, error, isFetching } = useQuery(
    ['bannerImgDropList', projectId],
    async () => await fetchNoticeDropList.bannerImageList(projectId),
  );
  return { status, data, error, isFetching };
};
